import API, { graphqlOperation } from '@aws-amplify/api'
import bodyParser from './bodyParser'
import awsConfig from '../aws-exports'
API.configure(awsConfig)

export default async ({ operation, path, variables }) => {
  const response = await API.graphql(graphqlOperation(operation, variables))
  return bodyParser({
    response,
    path
  })
}
